<template>
  <v-app id="app">
    <offline-indicator v-if="isOffline && displayApp"></offline-indicator>
    <loading v-if="!displayApp && !isErrorPage && !signUpRoute"></loading>
    <router-view
      ref="router-view"
      v-if="displayApp || authRoute || signUpRoute || isErrorPage"
    ></router-view>
    <CustomerEditorModals
      v-if="displayApp && showCustomerEditorModals"
      ref="customer-editor-modals"
    ></CustomerEditorModals>
    <!-- <Softphone ref="softphone"></Softphone> -->
  </v-app>
</template>

<script>
const jwtDecode = require("jwt-decode");
import {
  API_BASE_URL,
  AUTH_BASE_URL,
  AUTH_AUD,
  AUTH_ISS,
  RENEW_TOKEN_BEFORE_IN_SECONDS
} from "./globalVars";
import { Auth } from "aws-amplify";

const io = require("socket.io-client");
const socket = io(API_BASE_URL);

const Loading = () =>
  import(
    /* webpackChunkName: "components-global-Loading" */ `./components/global/Loading.vue`
  );
const OfflineIndicator = () =>
  import(
    /* webpackChunkName: "components-global-OfflineIndicator" */ `./components/global/OfflineIndicator.vue`
  );
// const Softphone = () =>
//   import(
//     /* webpackChunkName: "components-global-Softphone" */ `./components/global/Softphone.vue`
//   );
const CustomerEditorModals = () =>
  import(
    /* webpackChunkName: "components-customers-modals-CustomerEditorModals" */ `./components/customers/modals/CustomerEditorModals.vue`
  );

export default {
  name: "app",
  components: {
    OfflineIndicator,
    Loading,
    // Softphone,
    CustomerEditorModals
  },
  data() {
    return {
      timers: {
        waitForLoad: null,
        runSocket: null,
        runExpiredAccess: null
      },
      showApp: false,
      navMenuOpen: false,
      showCustomerEditorModals: false,
      token: null,
      userData: null,
      lastPing: 0
    };
  },
  created() {
    this.startup();

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  computed: {
    appSocket() {
      return socket;
    },
    testingRoute() {
      return [
        "customers",
        "inbox",
        "messages",
        "chats",
        "reviews",
        "settings",
        "calendar"
      ].includes(this.$route.name);
    },
    isOffline() {
      let settings = this.$store.getters["entities/settings/query"]().first();
      return settings != null ? settings.isOffline : false;
    },
    isAdmin() {
      return (
        this.user && (this.user.authRoleId == 2 || this.user.authRoleId == 1000)
      );
    },
    displayApp() {
      return this.showApp;
    },
    parsedToken() {
      return this.token
        ? jwtDecode(this.token)
        : localStorage.getItem("access_token")
        ? jwtDecode(localStorage.getItem("access_token"))
        : {};
    },
    telephonyToken() {
      let telephony = this.$store.getters["entities/telephony/query"]().first();
      return telephony && telephony.token ? telephony.token : null;
    },
    isAuthenticated() {
      let isAuth = null;
      try {
        const diff = this.parsedToken.exp - Date.now() / 1000;
        if (diff < RENEW_TOKEN_BEFORE_IN_SECONDS) {
          this.refreshTokens();
        }
        const aud = this.parsedToken.aud;
        const iss = this.parsedToken.iss;
        const exp = this.parsedToken.exp;
        isAuth =
          exp - Date.now() / 1000 > 0 && aud == AUTH_AUD && iss == AUTH_ISS;
      } catch (ex) {
        isAuth = false;
      }
      return isAuth;
    },
    authRoute() {
      return this.$route.name == "login";
    },
    signUpRoute() {
      return this.$route.name == "signup";
    },
    // accountId() {
    //   return this.$store.getters["entities/accounts/query"]().first();
    // },
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    isErrorPage() {
      return this.$route.path.substring(0, 7) == "/error/";
    },
    lastUpdateDateTime() {
      return this.$store.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
    }
  },
  methods: {
    async setupUserSession() {
      let vueThis = this;
      try {
        let user = await Auth.currentAuthenticatedUser({
          bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        localStorage.setItem(
          "access_token",
          user.signInUserSession.idToken.jwtToken
        );
        localStorage.setItem(
          "refresh_token",
          user.signInUserSession.refreshToken.token
        );
        vueThis.token = user.signInUserSession.idToken.jwtToken;
        vueThis.userData = user;
        vueThis.$honeybadger.setContext({
          userId: this.userId,
          accountId: this.user.accountId
        });
        //vueThis.$store.dispatch("entities/settings/setIsOffline", false);
      } catch (err) {
        vueThis.$store.dispatch("entities/settings/setIsOffline", true);
        //console.error(err);
      }
    },
    async startup() {
      let vueThis = this;
      if (
        !(window.location.pathname == "/sign-up/" && !vueThis.isAuthenticated)
      ) {
        await vueThis.setupUserSession();
        if (window.location.pathname != "/login/" && !vueThis.isAuthenticated) {
          if (vueThis.$route.name != "login") {
            vueThis.$router.push({ name: "login" });
          }
          setTimeout(vueThis.startup, 10000);
        } else if (
          window.location.pathname != "/login/" &&
          vueThis.isAuthenticated
        ) {
          vueThis.startUser();
          if (!vueThis.$route.name) {
            // vueThis.$router.push({ name: "customers" });
          }
        } else if (
          window.location.pathname == "/login/" &&
          vueThis.isAuthenticated
        ) {
          vueThis.startUser();
          vueThis.$router.push({ name: "customers" });
        } else if (
          window.location.pathname == "/login/" &&
          !vueThis.isAuthenticated
        ) {
          vueThis.timers.waitForLoad = setTimeout(function waitForLoad() {
            if (!vueThis.isAuthenticated) {
              setTimeout(vueThis.startup, 2000);
            }
          }, 2000);
        }

        vueThis.timers.runExpiredAccess = setTimeout(
          async function runExpiredAccess() {
            if (window.location.pathname !== "/login/") {
              const token = localStorage.getItem("access_token");
              if (!token) {
                vueThis.refreshTokens();
              } else if (!vueThis.parsedToken || !vueThis.parsedToken.exp) {
                vueThis.refreshTokens();
              } else {
                const diff = vueThis.parsedToken.exp - Date.now() / 1000;
                if (diff < RENEW_TOKEN_BEFORE_IN_SECONDS) {
                  vueThis.refreshTokens();
                } else if (diff <= 0) {
                  vueThis.refreshTokens();
                } else {
                  vueThis.timers.runExpiredAccess = setTimeout(
                    runExpiredAccess,
                    3000
                  );
                }
              }
            } else {
              vueThis.timers.runExpiredAccess = setTimeout(
                runExpiredAccess,
                3000
              );
            }
          }.bind(vueThis),
          3000
        );
      }
    },
    startUser() {
      let vueThis = this;
      let socketTimeout = 3000;
      this.fetchUser();
      vueThis.timers.runSocket = setTimeout(function runSocket() {
        if (!socket.connected && vueThis.isAuthenticated) {
          try {
            socket.connect();
            socketTimeout = 3000;
            vueThis.$store.dispatch("entities/settings/setIsOffline", false);
          } catch (error) {
            socketTimeout = Math.min(socketTimeout * 2, 1000 * 60 * 30);
            vueThis.$store.dispatch("entities/settings/setIsOffline", true);
          }
        }
        if (vueThis.isAuthenticated) {
          const diff = vueThis.parsedToken.exp - Date.now() / 1000;
          if (diff < RENEW_TOKEN_BEFORE_IN_SECONDS) {
            vueThis.refreshTokens();
          }
        }
        vueThis.timers.runSocket = setTimeout(runSocket, socketTimeout);
      }, socketTimeout);
    },
    async fetchUser() {
      let vueThis = this;
      if (vueThis.isAuthenticated) {
        vueThis.$store.dispatch("entities/settings/create", {
          data: {
            id: 1,
            accountId: 0,
            userId: 0,
            lastUpdateFromServer: 0,
            isOffline: false
          }
        });
        vueThis.$store.dispatch("entities/accounts/hydrate", 0);
        vueThis.$store.dispatch("entities/customerLookups/hydrate", 0);
        vueThis.$store.dispatch("entities/messageLookups/hydrate", 0);
        await vueThis.$store.dispatch("entities/users/hydrate", 0);
        const authUid = vueThis.parsedToken.sub;
        const allUsers = vueThis.$store.getters["entities/users/all"]();
        let user = allUsers.filter(function(row) {
          return authUid === row.authUid;
        })[0];
        if (!(user && user.accountId)) {
          // NO USER OR ACCCOUNT
          return;
        }
        await vueThis.$store.dispatch("entities/settings/create", {
          data: {
            id: 1,
            accountId: user.accountId,
            userId: user.id,
            lastUpdateFromServer: 0,
            isOffline: false
          }
        });
        vueThis.$store.dispatch("entities/userPreferences/hydrate", 0);
        vueThis.$store.dispatch("entities/settings/hydrate", 0);
        vueThis.$store.dispatch("entities/accounts/pingAccountLevelDisplay");
        vueThis.$store.dispatch("entities/listTypes/hydrate", 0);

        vueThis.showApp = true;

        // When we get connected from the server
        socket.on("disconnect", () => {
          try {
            socket.open();
          } catch (ex) {
            console.error("Open socket: " + JSON.stringify(ex));
          }
        });

        // When connected to the socket server
        socket.on("connect", () => {
          const token = localStorage.getItem("access_token");
          if (token) {
            socket.emit("user::find", {
              userId: vueThis.userId,
              accountId: vueThis.user.accountId,
              token: token,
              action: "connect"
            });
          }
        });

        if (socket.connected) {
          const token = localStorage.getItem("access_token");
          if (token) {
            socket.emit("user::find", {
              userId: vueThis.userId,
              accountId: vueThis.user.accountId,
              token: token,
              action: "connect"
            });
          }
        } else {
          try {
            socket.connect();
          } catch (ex) {
            console.error("Connecting socket: " + JSON.stringify(ex));
          }
        }

        // When real-time data updates come from the server
        socket.on("account updated", function(data) {
          const isCurrentCustomer =
            data.messageId &&
            vueThis.$store.state.entities.users.data[vueThis.userId]
              .currentCustomerId == data.customerId;
          if (data.messageId && isCurrentCustomer) {
            vueThis.$store.dispatch("entities/messages/fetchMessage", {
              accountId: data.accountId,
              messageId: data.messageId
            });
          } else if (data.chatId) {
            // console.log("update chatId " + data.chatId);
          } else {
            const currentTimeParse = Date.parse(new Date());
            const sufficientPingDelay =
              vueThis.lastPing + 5000 < currentTimeParse;
            if (sufficientPingDelay) {
              vueThis.$store.dispatch(
                "entities/accounts/pingAccountLevelDisplay"
              );
              vueThis.lastPing = Date.parse(new Date());
            }
          }
        });

        vueThis.$store.dispatch("entities/bizReviewSettings/hydrate", 0);

        if (vueThis.$route.path.substring(0, 7) == "/error/") {
          vueThis.$router.push({ name: "customers" });
        }
      } else {
        vueThis.showApp = false;
      }
    },
    logout() {
      localStorage.clear();
      let vueThis = this;
      vueThis.showApp = false;
      vueThis.token = null;
      vueThis.userData = null;
      Auth.signOut({ global: true })
        .then(data => {
          window.location.replace("/login");
        })
        .catch(err => console.error("logout error: " + JSON.stringify(err)));
    },
    async refreshTokens() {
      let vueThis = this;
      const refreshToken = localStorage.getItem("refresh_token");
      try {
        const response = await fetch(AUTH_BASE_URL, {
          headers: {
            "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
            "Content-Type": "application/x-amz-json-1.1"
          },
          //mode: 'cors',
          cache: "no-cache",
          method: "POST",
          body: JSON.stringify({
            ClientId: AUTH_AUD,
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: {
              REFRESH_TOKEN: refreshToken
            }
          })
        });
        const result = await response.json();
        if (result.AuthenticationResult) {
          var newAuthToken = result.AuthenticationResult.IdToken;
          localStorage.setItem("access_token", newAuthToken);
          vueThis.token = newAuthToken;
          vueThis.$store.dispatch("entities/settings/setIsOffline", false);
        } else if (result.message == "Refresh Token has expired") {
          // no refresh token...
          vueThis.logout();
        }
      } catch (error) {
        vueThis.$store.dispatch("entities/settings/setIsOffline", true);
        //vueThis.logout();
      }
    }
  }
};
</script>

<style lang="stylus">
#app
  font-family 'Avenir', 'Open Sans', Helvetica, Arial, sans-serif
</style>
